<template>
	<AppDialog v-model="isOpen" @close="onClose">
		<div class="tw-p-5" style="width: 40vw">
			<AppForm ref="form" @submit="onSubmit">
				<div class="content">
					<p class="tw-text-xl tw-font-semibold tw-text-gray-700">
						{{ $t('whatsapp.create-new-label') }}
					</p>
					<p class="mb-4 tw-text-base tw-font-normal tw-text-gray-600">
						{{ $t('whatsapp.label-dialog-description') }}
					</p>

					<template v-if="labelStore.loadingPage">
						<AppSkeleton class="mb-5" type="input" />
					</template>

					<template v-else>
						<AppInput
							:label="$t('whatsapp.label-name')"
							:placeholder="$t('whatsapp.label-name-place-holder')"
							v-model="labelStore.form.name"
							:rules="['required']"
						/>
					</template>
				</div>
				<div class="tw-mt-2 tw-flex tw-justify-end tw-gap-2">
					<AppButton
                        type="button"
                        @click="$refs.form.submit()"
						:loading="labelStore.loading"
						:label="$t(id ? 'whatsapp.update-label' : 'whatsapp.create-label')"
						size="lg"
					/>
					<AppButton
						:label="$t('cancel')"
						size="lg"
						secondary
						variant="gray"
						@click="isOpen = false"
					/>
				</div>
			</AppForm>
		</div>
	</AppDialog>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useLabelStore } from '@/v2/modules/whatsapp/stores/labels';
import AppSkeleton from '@/v2/components/skeleton.vue';
import AppDialog from '@/v2/components/dialog.vue';

const emit = defineEmits(['success']);

const labelStore = useLabelStore();

const isOpen = ref(false);
const id = ref(null);

const open = (idValue) => {
	isOpen.value = true;
	id.value = null;
	labelStore.reset();
	if (idValue) {
		labelStore.get(idValue);
		id.value = idValue;
	}
};

const onClose = () => {};

const onConfirm = () => {
	isOpen.value = false;
};

const onSubmit = async () => {
	const success = await labelStore.create(id.value);
	if (success) {
		onConfirm();
		emit('success');
	}
};

onUnmounted(() => {
	// labelStore.$reset();
	// labelStore.$dispose();
});

defineExpose({
	open,
});
</script>

<style lang="scss" scoped>
@import 'tailwindcss/base';
@import 'tailwindcss/utilities';
</style>
